import { WideWrap } from 'shared/components/Base/Base'
import { breakpoints } from 'shared/theme/breakpoints'
import { centeredContent } from 'shared/theme/mixins'
import styled from 'styled-components'

export const EmploymentHistoryContainer = styled(WideWrap)`
  ${centeredContent};
  flex-direction: column;
`

export const EmploymentHistoryItemsContainer = styled(WideWrap)`
  ${centeredContent};
  align-items: stretch;
  flex-direction: column;
  margin-bottom: 10px;
  width: 424px;
  max-width: 100%;
`

// todo @taylangocmen: remove $vertical and make it column by default
export const EmploymentHistoryRowContent = styled.div<{
  $large?: boolean
  $vertical?: boolean
}>`
  flex: 1;
  display: flex;
  flex-direction: ${(p) => (p.$vertical ? 'column' : 'row')};
  width: 100%;
  max-width: ${(p) => (p.$large ? '640px' : '424px')};
  min-width: 120px;

  & > div {
    width: 100%;
  }
`

export const EmploymentHistoryRowDoubleField = styled.div<{ $noMargin?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 424px;
  min-width: 120px;
  gap: 8px;
  margin-bottom: ${(p) => (p.$noMargin ? '0' : '24px')};

  @media ${breakpoints.xs} {
    display: block;
  }

  & > div {
    margin-bottom: 8px;
  }
`

export const EmploymentHistoryDotLookup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 8px;
`
